module.exports = __webpack_public_path__ + "img/sk.bb2211a4.svg";